<em-main>
  <div class="header">
    <h2 i18n>Recherche client</h2>
  </div>

  @if (tableEntries) {
    <p-card class="p-card container">
      <p-table
        [value]="tableEntries"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="true"
        [rowHover]="true"
        paginatorDropdownScrollHeight="160px"
        styleClass="sales-table"
        responsiveLayout="scroll"
        dataKey="id">
        <ng-template pTemplate="caption">
          <div class="table-section__header">
            <span i18n class="table-section__header--title">Liste des clients</span>
            <span class="p-input-icon-left w-4">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                [formControl]="filter"
                i18n-placeholder
                placeholder="Chercher par ID client, nom, courriel ou téléphone" />
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr class="table-section__thead">
            <th pSortableColumn="proposalCreatedAt" i18n
              >Date
              <p-sortIcon field="proposalCreatedAt"></p-sortIcon>
            </th>
            <th pSortableColumn="clientId" i18n
              >ID client
              <p-sortIcon field="clientId"></p-sortIcon>
            </th>
            <th pSortableColumn="fullName" i18n
              >Nom complet
              <p-sortIcon field="fullName"></p-sortIcon>
            </th>
            <th pSortableColumn="email" i18n
              >Courriel
              <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th pSortableColumn="phone" i18n
              >Téléphone
              <p-sortIcon field="phone"></p-sortIcon>
            </th>
            <th pSortableColumn="products" i18n
              >Produit(s)
              <p-sortIcon field="products"></p-sortIcon>
            </th>
            <th pSortableColumn="monthlyPrice" i18n
              >Prime mensuelle
              <p-sortIcon field="monthlyPrice"></p-sortIcon>
            </th>
            <th i18n>Progression</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-tableEntry>
          <tr class="status">
            <td>{{ tableEntry.proposalCreatedAt ? (tableEntry.proposalCreatedAt | emDate) : '--' }}</td>
            <td>{{ tableEntry.clientId || '--' }}</td>
            <td>{{ tableEntry.fullName || '--' }}</td>
            <td>{{ tableEntry.email || '--' }}</td>
            <td>{{ tableEntry.phone | emPhone }}</td>
            <td>
              <div class="flex flex-wrap gap-1">
                @for (product of tableEntry.products; track product) {
                  <span
                    class="product"
                    [ngClass]="{
                      'product--term': product.type === productTypeNg.TERM_LIFE,
                      'product--whole': product.type === productTypeNg.WHOLE_LIFE,
                      'product--rider': product.type === productTypeNg.RIDER,
                    }"
                    i18n
                    >{{ product.name }}</span
                  >
                }
              </div>
            </td>
            <td>{{ (tableEntry.monthlyPrice | currency: 'CAD' : 'symbol-narrow') || '--' }}</td>
            <td class="min-w-[360px]">
              <p-button
                class="progress-button"
                (onClick)="createProposal(tableEntry)"
                i18n-label
                label="Créer la proposition"
                icon="pi pi-pencil"
                iconPos="left"></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p class="mt-4"><em i18n>Le tableau affiche uniquement les clients provenant du « self-serve ».</em></p>
    </p-card>
  }
</em-main>

<p-toast></p-toast>
